/* eslint-disable no-restricted-imports */
import { forwardRef } from 'react';
import {
    MenuItem as ArcMenuItem,
    MenuItemProps,
    PolymorphicMenuListItem,
    cssVar,
    styled,
} from 'arc';
import { useApplicationType } from '../../../common/hooks/use-application-type';

const EnlargedMenuItem = styled(ArcMenuItem)`
    font-size: ${cssVar('arc.fontSizes.lg')};
    height: ${cssVar('arc.sizes.12')};
`;

export const MenuItem = forwardRef(function (
    props: MenuItemProps & PolymorphicMenuListItem,
    ref?: React.Ref<HTMLElement>
) {
    const { isCad } = useApplicationType();

    if (isCad) {
        return (
            <ArcMenuItem ref={ref} {...props}>
                {props.children}
            </ArcMenuItem>
        );
    }

    return (
        // <div> is needed for menu list layout
        <div>
            <EnlargedMenuItem ref={ref} {...props}>
                {props.children}
            </EnlargedMenuItem>
        </div>
    );
});
